module.exports = __webpack_public_path__ + "media/Arrow_MelbourneCBD.7b763a9a.svg";